module.exports = __webpack_public_path__ + "static/media/banner-agenda-de-cursos-instituto-licitar-licitacao-14133.0a8fd45c.png";